import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import Stepper from "../../../../../../Component/Stepper";
import Configure from "./configure";
import SectionA from "./sectionA";
import SectionB from "./sectionB";
import Preview from "./preview";

export default class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      AllStep: [],
      issetionb: true,
      completed: false,
      selectedData: props.selectedData || null,
    };

    this.setStep = this.setStep.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.onSkipClick = this.onSkipClick.bind(this);
    this.onSkipClick1 = this.onSkipClick1.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.updateStepsData = this.updateStepsData.bind(this);
    this.setNull = this.setNull.bind(this);
  }

  componentDidMount() {
    this.updateStepsData();
  }

  setStep(step, completed) {
    this.setState({ activeStep: step, completed });
  }

  updateStepsData() {
    const AllStep = [
      {
        component: (
          <Configure
            onRef={(ref) =>
              this.setState({
                child0: {
                  ...ref,
                  onCancel: this.onCancel,
                },
              })
            }
            {...this.props}
            {...this.state}
            onNextClick={this.onNextClick}
            onSkipClick1={this.onSkipClick1}
            setStep={this.setStep}
          />
        ),
        iserror: false,
        label: "Configure",
        step: 0,
      },
      {
        component: (
          <SectionA
            onRef={(ref) =>
              this.setState({
                child1: {
                  ...ref,
                  onCancel: this.onCancel,
                  onPrev: this.onPrevClick,
                },
              })
            }
            {...this.props}
            {...this.state}
            onNextClick={this.onNextClick}
            setStep={this.setStep}
          />
        ),
        iserror: false,
        label: "Section A",
        step: 1,
      },
      {
        component: (
          <SectionB
            onRef={(ref) =>
              this.setState({
                child2: {
                  ...ref,
                  onCancel: this.onCancel,
                  onPrev: this.onPrevClick,
                },
              })
            }
            {...this.props}
            {...this.state}
            onNextClick={this.onNextClick}
            onResetClick={this.onResetClick}
            onSkipClick={this.onSkipClick}
            setStep={this.setStep}
            setNull={this.setNull}
          />
        ),
        iserror: false,
        label: "Section B",
        step: 2,
      },
      {
        component: (
          this.state.issetionb ?
            <Preview
              onRef={(ref) =>
                this.setState({
                  child3: {
                    ...ref,
                    onCancel: this.onCancel,
                    onPrev: this.onPrevClick,
                    nextButtonLabel: "Save",
                  },
                })
              }
              {...this.props}
              {...this.state}
              onNextClick={this.onNextClick}
              setStep={this.setStep}
              setNull={this.setNull}
            />
            : <Preview
              onRef={(ref) =>
                this.setState({
                  child2: {
                    ...ref,
                    onCancel: this.onCancel,
                    onPrev: this.onPrevClick,
                    nextButtonLabel: "Save",
                  },
                })
              }
              {...this.props}
              {...this.state}
              onNextClick={this.onNextClick}
              setStep={this.setStep}
              setNull={this.setNull}
            />
        ),
        iserror: false,
        label: "Preview",
        step: this.state.issetionb ? 3 : 2,
      },
    ];
    if (!this.state.issetionb) {
      AllStep.splice(2, 1);
    }
    // this.setState({ postData, AllStep });
    this.setState({ AllStep });
  }

  setNull() {
    this.setState(
      {
        selectedPolicy: null,
      },
      () => {
        this.props.getList();
      },
    );
  }

  OnSaveDraft = () => {
    this.OnSave(true);
  };

  onNextClick(selectedData) {
    this.setState({
      selectedData,
    }, () => {
      if (this.child) {
        this.child.handleNext();
      }
    });
  }

  onSkipClick(selectedData) {
    this.setState({
      selectedData,
    }, () => {
      if (this.child) {
        this.child.handleSkip(1);
      }
    });
  }

  onSkipClick1(selectedData, value) {
    this.setState({
      selectedData,
      issetionb: value,
    }, () => {
      this.updateStepsData();
    });
  }

  onResetClick(selectedData) {
    this.setState({
      selectedData,
    });
  }

  onCancel() {
    this.props.onCancel();
    const obj = {
      focusareaid: null,
      focusareaname: "Focus area 1",
      competencyid: null,
      reviewquestion: [],
    };
    const area = [];
    area.push(obj);
    const selectedData = {
      reviewformid: null,
      formtitle: null,
      reviewstructureid: null,
      isdraft: true,
      formfor: {
        reviewformforid: null,
        fortypeid: null,
        forids: null,
      },
      section: [
        {
          reviewsectionid: null,
          sectionname: "Result",
          weightagetypeid: null,
          focusarea: area,
        },
        {
          reviewsectionid: null,
          sectionname: "Behaviour",
          weightagetypeid: null,
          focusarea: area,
        },
      ],
    };
    this.setState({
      selectedData,
    });
  }

  onPrevClick() {
    this.child.handleBack();
  }

  render() {
    const { child0, child1, child2, child3 } = this.state;

    return (
      <div>
        <IntlProvider locale="en">
          <div className="content-outer-wrapper">
            <div>
              <div style={{ display: "block", width: "100%" }}>
                <Stepper
                  AllStep={this.state.AllStep}
                  onRef={(ref) => (this.child = ref)}
                  activeStep={this.state.activeStep}
                  setStep={this.setStep}
                  completed={this.state.completed}
                  childs={[child0, child1, child2, child3]}
                />
              </div>
            </div>
          </div>
        </IntlProvider>
      </div>
    );
  }
}
